export default __webpack_public_path__ + "static/media/done1.d4f52131.svg";